import { memo } from 'react';
import { InputAdornment, SxProps, Theme } from '@mui/material';
import { StyledCurrencyInput, CurrencyInputVariant } from './styles';
import useCurrencyFormat from './useCurrencyFormat';

interface CurrencyInputProps {
  value: number | null;
  error?: boolean;
  helperText?: string;
  label?: string;
  placeholder?: string;
  size?: 'small' | 'medium';
  disabled?: boolean;
  fullWidth?: boolean;
  onChange?: (value: number | null) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  variant?: CurrencyInputVariant;
  sx?: SxProps<Theme>;
  endAdornment?: React.ReactNode;
}

const CurrencyInput = memo(
  ({
    value,
    error = false,
    helperText,
    label = '',
    placeholder = '',
    disabled = false,
    fullWidth = false,
    onChange,
    onFocus,
    onBlur,
    size = 'medium',
    variant = 'default',
    sx,
    endAdornment,
  }: CurrencyInputProps) => {
    const { formattedValue, handleChange } = useCurrencyFormat({
      value,
      onChange,
    });

    return (
      <StyledCurrencyInput
        type="text"
        size={size}
        label={label}
        placeholder={placeholder}
        value={formattedValue}
        onChange={handleChange}
        onFocus={onFocus}
        onBlur={onBlur}
        disabled={disabled}
        fullWidth={fullWidth}
        customVariant={variant}
        sx={sx}
        error={error}
        helperText={helperText}
        InputProps={{
          endAdornment: endAdornment ? (
            <InputAdornment position="end">{endAdornment}</InputAdornment>
          ) : undefined,
        }}
      />
    );
  },
);

CurrencyInput.displayName = 'CurrencyInput';

export default CurrencyInput;
